import { createSlice } from "@reduxjs/toolkit";

const globalDataSlice = createSlice({
  name: "globalData",
  initialState: {
    globalDataName: {}, // Store API response here
  },
  reducers: {
    setglobalData(state, action) {
      state.globalDataName = action.payload; // Update state correctly
    },
  },
});

export const { setglobalData } = globalDataSlice.actions;
export default globalDataSlice.reducer;
